export default __webpack_public_path__ + "static/media/list_bullet_light.9cc14cfa.svg";